import React from 'react';
import {
  Users,
  Package,
  FileText,
  Settings,
  BarChart3,
  Bell,
  Database,
  MapPin,
  Activity,
  DollarSign,
  LayoutDashboard,
  ClipboardCheck,
  Hourglass,
  FileQuestion,
  ScrollText,
} from 'lucide-react';
import ConsoleLayout from '../shared/ConsoleLayout';

// Menu groups. `roles`: 'admin' = system admins only, 'company' = company admins
// only (not system admins), 'both' = either. `match` lists extra path prefixes
// that should highlight the item (e.g. detail pages under a different path).
const MENU = [
  {
    group: null,
    items: [
      { path: '/admin', icon: LayoutDashboard, label: 'Dashboard', exact: true, roles: 'admin' },
      { path: '/admin/company-dashboard', icon: LayoutDashboard, label: 'Company Dashboard', exact: true, roles: 'company' },
    ],
  },
  {
    group: 'Orders',
    items: [
      { path: '/admin/approvals', icon: ClipboardCheck, label: 'Order Approvals', roles: 'admin', badge: 'approvals' },
      { path: '/admin/orders', icon: Package, label: 'Orders', roles: 'admin' },
      { path: '/admin/company-orders', icon: Package, label: 'Company Orders', roles: 'company' },
      { path: '/admin/backorders', icon: Hourglass, label: 'Backorders', roles: 'admin' },
      { path: '/admin/inquiries', icon: FileQuestion, label: 'Inquiries (RFQ)', roles: 'admin', match: ['/admin/inquiry/'] },
    ],
  },
  {
    group: 'Customers',
    items: [
      { path: '/admin/users', icon: Users, label: 'Users', roles: 'both' },
      { path: '/admin/delivery-addresses', icon: MapPin, label: 'Delivery Addresses', roles: 'both' },
      { path: '/admin/notifications', icon: Bell, label: 'Customer Notifications', roles: 'admin' },
    ],
  },
  {
    group: 'Catalogue',
    items: [
      { path: '/admin/products', icon: Database, label: 'Products', roles: 'admin' },
      { path: '/admin/price-schedules', icon: DollarSign, label: 'Price Schedules', roles: 'admin' },
      { path: '/admin/content', icon: FileText, label: 'Content', roles: 'admin' },
      { path: '/admin/changelog', icon: ScrollText, label: 'Changelog', roles: 'admin' },
    ],
  },
  {
    group: 'Insights',
    items: [
      { path: '/admin/search-analytics', icon: BarChart3, label: 'Search Analytics', roles: 'admin' },
    ],
  },
  {
    group: 'System',
    items: [
      { path: '/admin/queue-monitor', icon: Activity, label: 'Task Queue', roles: 'admin' },
      { path: '/admin/settings', icon: Settings, label: 'Settings', roles: 'admin', match: ['/admin/system-settings'] },
    ],
  },
];

const canSee = (item, account) => {
  if (item.roles === 'both') return true;
  if (item.roles === 'admin') return !!account?.is_admin;
  return !account?.is_admin && !!account?.is_company_admin;
};

const getBrand = (account) => {
  const companyAdminOnly = account && !account.is_admin && account.is_company_admin;
  return companyAdminOnly
    ? { title: 'Company Admin', subtitle: account.company_name, homePath: '/admin/company-dashboard', rootLabel: 'Company Admin' }
    : { title: 'Admin Console', subtitle: 'Partner Portal', homePath: '/admin', rootLabel: 'Admin' };
};

const AdminLayout = ({ children }) => (
  <ConsoleLayout menu={MENU} canSee={canSee} getBrand={getBrand}>
    {children}
  </ConsoleLayout>
);

export default AdminLayout;
